import React from "react";
import { HEADING } from "../../heading/constants/constants";
import Heading from "../../heading/Heading";
import { VEC_ICON_NAME } from "../../icons/constants";
import Icons from "../../icons/Icons";
import BasicCard from "../basiccard/BasicCard";
import styles from "./CardWBottomIcon.styles";


export default function CardWBottomIcon({
    icon,
    title,
    subText,
    linkButtonText,
    alignItems,
    justifyContent = "space-between",
    isHighlighted = false,
    customStyles = {},
    fullWidth = false,
    isFilled = false,
}) {
    return (
        <>
            <BasicCard
                isHighlighted={isHighlighted}
                customStyles={{ ...styles.parentPadding, ...customStyles }}
                fullWidth={fullWidth}
                alignItems={alignItems}
                justifyContent={justifyContent}
            >
                <div>
                    {title && (
                        <Heading type={HEADING.H2} customStyle={styles.cardTitle}>
                            {title}
                        </Heading>
                    )}

                    {subText && <p>{subText}</p>}

                    {linkButtonText && <button style={styles.cardButton}>{linkButtonText}</button>}
                </div>

                <div>
                    <div className="mt-5">
                        <Icons familyName="vec" iconName={VEC_ICON_NAME.INFO_ICON} /> &nbsp;
                        <a style={styles.needHelpLabel}>Need Help</a>
                    </div>

                    {icon && (
                        <div style={styles.bottomIcon}>
                            <Icons familyName="vec" iconName={icon} />
                        </div>
                    )}
                </div>
            </BasicCard>
        </>
    );
}
